import * as actions from "./actionsTypes";

const initialData = {
  loaderCollaboratorsEvaluate: false,
  collaboratorsEvaluate: null,
  saveLoaderCollaboratorsEvaluate: false,
  collaboratorsEvaluateFormError: null,
  collaboratorsEvaluateFail: null,
  //
  loaderCollaboratorsEvaluateGeneral: false,
  collaboratorsEvaluateGeneral: null,
  collaboratorsEvaluateFailGeneral: null,
  collaboratorsEvaluateGeneralFormError: null,
  saveLoaderCollaboratorsEvaluateGeneral: false,
  //
  loaderEvaluators: false,
  saveLoaderEvaluators: false,
  evaluators: null,
  evaluatorsFormError: null,
  evaluatorsFail: null,
  //
  loaderPeriod: false,
  period: null,
  periodFail: null,
};

export default function CollaboratorsEvaluateReducer(
  state = initialData,
  action
) {
  switch (action.type) {
    case actions.LOADER_COLLABORATORS_TO_EVALUATE:
      return { ...state, loaderCollaboratorsEvaluate: action.payload };

    case actions.LOADER_COLLABORATORS_TO_EVALUATE_GENERAL:
      return { ...state, loaderCollaboratorsEvaluateGeneral: action.payload };

    case actions.LOADER_EVALUATORS:
      return { ...state, loaderEvaluators: action.payload };

    case actions.LOADER_PERIOD:
      return { ...state, loaderPeriod: action.payload };

    case actions.GET_COLLABORATORS_TO_EVALUATE:
      return { ...state, collaboratorsEvaluate: action.payload };

    case actions.GET_COLLABORATORS_TO_EVALUATE_GENERAL:
      return { ...state, collaboratorsEvaluateGeneral: action.payload };

    case actions.GET_EVALUATORS:
      return { ...state, evaluators: action.payload };

    case actions.GET_PERIOD:
      return { ...state, period: action.payload };

    case actions.COLLABORATORS_TO_EVALUATE_FAIL:
      return { ...state, collaboratorsEvaluateFail: action.payload };

    case actions.COLLABORATORS_TO_EVALUATE_FAIL_GENERAL:
      return { ...state, collaboratorsEvaluateFailGeneral: action.payload };

    case actions.EVALUATORS_FAIL:
      return { ...state, evaluatorsFail: action.payload };

    case actions.PERIOD_FAIL:
      return { ...state, periodFail: action.payload };

    case actions.SAVE_LOADER_COLLABORATORS_TO_EVALUATE:
      return { ...state, saveLoaderCollaboratorsEvaluate: action.payload };

    case actions.SAVE_LOADER_COLLABORATORS_TO_EVALUATE_GENERAL:
      return {
        ...state,
        saveLoaderCollaboratorsEvaluateGeneral: action.payload,
      };

    case actions.SAVE_LOADER_EVALUATORS:
      return { ...state, saveLoaderEvaluators: action.payload };

    case actions.FORM_COLLABORATORS_TO_EVALUATE_FAIL:
      return { ...state, collaboratorsEvaluateFormError: action.payload };

    case actions.FORM_EVALUATORS_FAIL:
      return { ...state, evaluatorsFormError: action.payload };

    case actions.FORM_COLLABORATORS_TO_EVALUATE_FAIL_GENERAL:
      return {
        ...state,
        collaboratorsEvaluateGeneralFormError: action.payload,
      };

    default:
      return state;
  }
}
